import React, { useEffect } from 'react'

import { notify } from '@offerzen/react-utils'
import { Card, LazyImage, Heading } from '@offerzen/pinata-shame'
import SceneLayout from '../../components/SceneLayout'

import styles from './styles'

/**
 * @typedef {Object} User
 * @property {string} [id]
 * @property {string} [name]
 * @property {string} [email]
 * @property {string} [role]
 */

/**
 * @typedef {Object} Error
 * @property {string} [message]
 */

/**
 * CandidateExperienceError component
 *
 * @param {Object} props
 * @param {User} [props.user]
 * @param {Error} [props.error]
 *
 * @returns {JSX.Element}
 */
const CandidateExperienceError = ({ user, error }) => {
  useEffect(() => {
    const safeErrorMessage = error?.message && error.message.trim().split(/\n/g)[0]
    notify('😾 - user is viewing the grumpy cat', user, { errorMessage: safeErrorMessage })
  }, [user, error])

  return (
    <SceneLayout>
      <Card className={styles.card}>
        <LazyImage loader={() => import('../../../assets/grumpy-cat-sitting.svg')} alt="" width={280} />
        <Heading>Something went wrong. How awful.</Heading>
      </Card>
    </SceneLayout>
  )
}

export default CandidateExperienceError
